import type { YieldFileType } from '@/features/assets/constants'
import { createClient } from '@/shared/api/client'
import { TargetSystem } from '@/shared/constants'
import { buildUrl } from '@/shared/utils/urls'
import { validateResponseIsOk } from '@/shared/api/validation'

const client = createClient(buildUrl(TargetSystem.AssetManagement))

export async function removeYieldFile(assetCode: string, fileType: YieldFileType) {
  await validateResponseIsOk(
    client.sendDelete(['assets', assetCode, 'yields', 'files', fileType])
  )
}
